/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_CreditsInputs */

const en_landing_studio_credits = /** @type {(inputs: Landing_Studio_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`credits`)
};

const zh_landing_studio_credits = /** @type {(inputs: Landing_Studio_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分`)
};

/**
* | output |
* | --- |
* | "credits" |
*
* @param {Landing_Studio_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_credits = /** @type {((inputs?: Landing_Studio_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_credits(inputs)
	return zh_landing_studio_credits(inputs)
});
export { landing_studio_credits as "landing.studio.credits" }